/* ============================================================
   KX ANIMATIONS — IntersectionObserver scroll reveal
   Korexus premium animation system
   ============================================================ */

(function () {
  'use strict';

  // Respeta la preferencia del usuario de reducir movimiento
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // ── IntersectionObserver ─────────────────────────────────
  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('kx-visible');
        observer.unobserve(entry.target); // Solo anima una vez
      });
    },
    {
      threshold: 0.08,
      rootMargin: '0px 0px -36px 0px'
    }
  );

  // ── Helpers ──────────────────────────────────────────────

  function observeGroup(selector, baseDelay, step) {
    var els = document.querySelectorAll(selector);
    els.forEach(function (el, i) {
      if (el.closest('.kx-animate')) return; // evitar doble animación
      el.classList.add('kx-animate', 'kx-fade-up');
      el.style.setProperty('--kx-delay', (baseDelay + i * step) + 'ms');
      observer.observe(el);
    });
  }

  function observeEl(el, delay) {
    if (!el) return;
    el.classList.add('kx-animate', 'kx-fade-up');
    el.style.setProperty('--kx-delay', (delay || 0) + 'ms');
    observer.observe(el);
  }

  // ── Init ─────────────────────────────────────────────────

  function init() {

    // 1. Hero / Banner — animación de entrada secuencial
    document.querySelectorAll('.banner:not(.slideshow)').forEach(function (banner) {
      observeEl(banner.querySelector('.banner__heading'), 0);
      observeEl(banner.querySelector('.banner__text'), 130);
      observeEl(banner.querySelector('.banner__button-group'), 260);

      // Imagen flotante (solo banners estáticos con imagen)
      var media = banner.querySelector('.banner__media');
      if (media) media.classList.add('kx-floating');
    });

    // Slideshow: animar el contenido de cada slide al entrar
    document.querySelectorAll('.slideshow__slide').forEach(function (slide) {
      observeEl(slide.querySelector('h1, h2, .banner__heading'), 0);
      observeEl(slide.querySelector('p, .banner__text'), 120);
      observeEl(slide.querySelector('.button, .banner__button-group'), 240);
    });

    // 2. Secciones — headings y subheadings
    observeGroup('.section-header', 0, 0);
    observeGroup('.rich-text__heading', 0, 0);
    observeGroup('.rich-text__text', 80, 0);

    // 3. Productos destacados — entrada progresiva (stagger 70ms)
    observeGroup(
      '.featured-collection .card-wrapper, ' +
      '.product-grid .card-wrapper, ' +
      '.collection-product-card',
      0, 70
    );

    // 4. Colecciones / categorías (stagger 80ms)
    observeGroup('.collection-list__item', 0, 80);

    // 5. Multicolumna — features, beneficios (stagger 80ms)
    observeGroup('.multicolumn-list__item', 0, 80);

    // 6. Image with text — animación por mitades
    document.querySelectorAll('.image-with-text').forEach(function (section) {
      observeEl(section.querySelector('.image-with-text__content'), 0);
      observeEl(section.querySelector('.image-with-text__media'), 150);
    });

    // 7. Featured image / media section
    observeGroup('.media-with-text__content > *', 0, 100);

    // 8. Blogs / artículos
    observeGroup('.blog-articles .article-card', 0, 80);

    // 9. Texto enriquecido (rich text blocks)
    document.querySelectorAll('.rich-text__wrapper').forEach(function (block) {
      var children = block.children;
      for (var i = 0; i < children.length; i++) {
        observeEl(children[i], i * 90);
      }
    });

    // 10. Footer columns
    observeGroup('.footer__column', 0, 60);

    // 11. Cualquier elemento marcado manualmente con .kx-animate
    document.querySelectorAll('.kx-animate:not([style*="--kx-delay"])').forEach(function (el) {
      observer.observe(el);
    });

    // 12. Fade suave en imágenes lazy al cargar
    document.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      if (img.complete) {
        img.classList.add('loaded');
      } else {
        img.addEventListener('load', function () { img.classList.add('loaded'); });
      }
    });

  }

  // Ejecutar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Fallback: si algún elemento no fue revelado por el observer en 2s, revelarlo igual
  setTimeout(function () {
    document.querySelectorAll('.kx-animate:not(.kx-visible)').forEach(function (el) {
      el.classList.add('kx-visible');
    });
  }, 2000);

})();




/* ============================================================
   KX LAZY IMAGE FIX — Imágenes inyectadas via AJAX
   Cart drawer y product-recommendations usan innerHTML para
   insertar contenido. Los img[loading="lazy"] recién insertados
   no siempre disparan el lazy loader nativo del browser.
   Este MutationObserver los convierte a eager apenas entran al DOM.
   Solo afecta imágenes añadidas dinámicamente (no las del parse inicial).
   ============================================================ */

(function () {
  'use strict';

  function unlazify(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.tagName === 'IMG' && node.getAttribute('loading') === 'lazy') {
      node.loading = 'eager';
    }
    var imgs = node.querySelectorAll('img[loading="lazy"]');
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].loading = 'eager';
    }
  }

  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        unlazify(added[j]);
      }
    }
  });

  mo.observe(document.documentElement, { childList: true, subtree: true });

})();
